import React from "react"
import styled, { css } from "styled-components"

import CarouselSelectionOptions from "./CarouselSelectionOptions"

const StyledHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  color: var(--gray-text);
  margin: 10px;
  user-select: none;
`

type Selectable = {
  readonly selected: boolean;
}

const StyledSelectableText = styled.span<Selectable>`
  color: var(--gray-text);
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 2px;
  
  ${props => props.selected && css`
    color: var(--darkblue);
    background-color: var(--white);
    border-radius: 5px;
  `}
`

type SelectableTextProps = {
  text: string
  selected: boolean
}

const SelectableText = ({text, selected}: SelectableTextProps) =>
  <StyledSelectableText selected={selected}>
    {text}
  </StyledSelectableText>
  

const Left = styled.div` 
  text-align: left;
`

const Center = styled.div`
  text-align: center;
`

const Right = styled.div`
  text-align: right;
`
type Props = {
  left: string
  center: string
  right: string
  selected: CarouselSelectionOptions
  setActiveTab: (column: CarouselSelectionOptions) => void
}

const CarouselHeader = ({left, center, right, selected, setActiveTab}: Props) => {
  
  return (
    <StyledHeader>
      <Left onClick={() => setActiveTab(CarouselSelectionOptions.LEFT)}>
        <SelectableText
          text={left}
          selected={selected === CarouselSelectionOptions.LEFT}
        />
      </Left>

      <Center onClick={() => setActiveTab(CarouselSelectionOptions.CENTER)}>
        <SelectableText
          text={center}
          selected={selected === CarouselSelectionOptions.CENTER}
        />
      </Center>

      <Right onClick={() => setActiveTab(CarouselSelectionOptions.RIGHT)}>
        <SelectableText
          text={right}
          selected={selected === CarouselSelectionOptions.RIGHT}
        />
      </Right>
    </StyledHeader>
  )
}

export default CarouselHeader